import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import AuthPage from "../../components/auth/AuthPage";
import OtpField from "../../components/auth/OtpField";
import ResendTimer from "../../components/auth/ResendTimer";
import SubmitButton from "../../components/auth/SubmitButton";
import { API } from "../../constant/api";
import sessionAxios from "../../utils/sessionAxios";
import { useCountdown } from "../../hooks/use-countdown";
import { errorMessage } from "../../utils/errorMessage";

const VerifyMail = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const countdown = useCountdown(119);

  const verify = (code: string) => {
    if (loading) return;
    if (code.length !== 6) {
      toast.error("Enter all 6 digits");
      return;
    }
    setLoading(true);

    sessionAxios
      .post(API.verifyEmail, { otp: code })
      .then(() => {
        setLoading(false);
        toast.success("Your email is verified.");
        navigate("/business");
      })
      .catch((e: any) => {
        setLoading(false);
        toast.error(
          errorMessage(
            e?.response?.data?.message || "An error occurred during verification"
          )
        );
      });
  };

  const resendOtp = () => {
    sessionAxios
      .post(API.requestOTP, { purpose: "email-verification" })
      .then((r: any) => toast.success(r.data.message))
      .catch((e: any) => {
        toast.error(
          errorMessage(
            e?.response?.data?.message || "An error occurred while resending OTP"
          )
        );
      });

    countdown.restart(119);
  };

  return (
    <AuthPage
      title="Verify your email"
      description="Add the OTP sent to your mail to continue."
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          verify(otp);
        }}
        className="space-y-6"
      >
        <OtpField value={otp} onChange={setOtp} onComplete={verify} />

        <ResendTimer
          isRunning={countdown.isRunning}
          label={countdown.label}
          onResend={resendOtp}
        />

        <SubmitButton loading={loading}>Verify account</SubmitButton>
      </form>
    </AuthPage>
  );
};

export default VerifyMail;
